module.exports = __webpack_public_path__ + "static/media/carousal-l.569e1798.svg";